// extracted by mini-css-extract-plugin
export default {"item":"SigEventsListItem_item__ekuvQ","icon":"SigEventsListItem_icon__WWm3x","title":"SigEventsListItem_title__YuWjB","timestamp":"SigEventsListItem_timestamp__00ezm"};